var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
const SvgStack = _a => {
  var _b, _c, _d, _e, _f, _g;
  var {
      size
    } = _a,
    props = __rest(_a, ["size"]);
  return React.createElement("svg", Object.assign({
    width: size !== null && size !== void 0 ? size : 24,
    height: size !== null && size !== void 0 ? size : 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: props.role,
    "aria-hidden": (_b = props['aria-hidden']) !== null && _b !== void 0 ? _b : true
  }, props), React.createElement("g", {
    clipPath: "url(#clip0_2667_5668)"
  }, React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4372 16.1993C20.6032 16.5788 20.4301 17.021 20.0507 17.1871L12.6713 20.4156C12.0789 20.6747 11.4048 20.6665 10.819 20.3931L3.93361 17.1799L4.25005 16.4999L4.56726 15.8203L11.4533 19.0338C11.6486 19.125 11.8726 19.1277 12.07 19.0413L19.4494 15.8128C19.8289 15.6468 20.2711 15.8198 20.4372 16.1993ZM3.57041 16.1828C3.74557 15.8074 4.1919 15.6452 4.56726 15.8203L4.25005 16.4999L3.93361 17.1799C3.55825 17.0048 3.39524 16.5581 3.57041 16.1828Z",
    fill: (_c = props.color) !== null && _c !== void 0 ? _c : 'currentColor'
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4372 11.6993C20.6032 12.0788 20.4301 12.521 20.0507 12.6871L12.6713 15.9156C12.0789 16.1747 11.4048 16.1665 10.819 15.8931L3.93361 12.6799L4.25005 11.9999L4.56726 11.3203L11.4533 14.5338C11.6486 14.625 11.8726 14.6277 12.07 14.5413L19.4494 11.3128C19.8289 11.1468 20.2711 11.3198 20.4372 11.6993ZM3.57041 11.6828C3.74557 11.3074 4.1919 11.1452 4.56726 11.3203L4.25005 11.9999L3.93361 12.6799C3.55825 12.5048 3.39524 12.0581 3.57041 11.6828Z",
    fill: (_d = props.color) !== null && _d !== void 0 ? _d : 'currentColor'
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4372 7.19933C20.6032 7.57882 20.4301 8.02104 20.0507 8.18706L12.6713 11.4156C12.0789 11.6747 11.4048 11.6665 10.819 11.3931L3.93361 8.17992L4.25005 7.49995L4.56726 6.82033L11.4533 10.0338C11.6486 10.125 11.8726 10.1277 12.07 10.0413L19.4494 6.81283C19.8289 6.6468 20.2711 6.81985 20.4372 7.19933ZM3.57041 7.18278C3.74557 6.80743 4.1919 6.64516 4.56726 6.82033L4.25005 7.49995L3.93361 8.17992C3.55825 8.00476 3.39524 7.55813 3.57041 7.18278Z",
    fill: (_e = props.color) !== null && _e !== void 0 ? _e : 'currentColor'
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4372 7.80055C20.6032 7.42106 20.4301 6.97884 20.0507 6.81281L12.6713 3.58432C12.0789 3.32516 11.4048 3.33342 10.819 3.6068L3.93361 6.81996L4.25005 7.49993L4.56726 8.17955L11.4533 4.96607C11.6486 4.87491 11.8726 4.8722 12.07 4.95856L19.4494 8.18705C19.8289 8.35308 20.2711 8.18003 20.4372 7.80055ZM3.57041 7.8171C3.74557 8.19245 4.1919 8.35471 4.56726 8.17955L4.25005 7.49993L3.93361 6.81996C3.55825 6.99512 3.39524 7.44174 3.57041 7.8171Z",
    fill: (_f = props.color) !== null && _f !== void 0 ? _f : 'currentColor'
  })), React.createElement("defs", null, React.createElement("clipPath", {
    id: "clip0_2667_5668"
  }, React.createElement("rect", {
    width: 17.0002,
    height: 17.2085,
    fill: (_g = props.color) !== null && _g !== void 0 ? _g : 'currentColor',
    transform: "translate(3.5 3.39575)"
  }))));
};
export default SvgStack;